import React from 'react';

import {
  DescriptionItem,
  DescriptionList,
  Link,
  Paper,
  Typography,
} from '@gogame/components';

import { CampaignDetails } from 'scenes/Campaigns/GGCampaigns/components/CampaignDetails';
import AffiliateDetails from 'scenes/Affiliates/components/AffiliateDetails';

export default ({ data, openChildComponent }) => {
  const handleOpenAffiliate = () => {
    openChildComponent(AffiliateDetails, {
      id: data?.affiliate?.id,
    });
  };

  const handleOpenCampaign = () => {
    openChildComponent(CampaignDetails, {
      id: data?.campaign?.id,
    });
  };
  return {
    color: 'success',
    date: data.time,
    title: (
      <Typography>
        <span>Reengagement - </span>
        <Link onClick={handleOpenCampaign}>{data?.campaign?.name}</Link>
        <span> ({data?.campaign?.owner})</span>
      </Typography>
    ),
    content: (
      <Paper
        sx={{ padding: 2, marginTop: 1, width: '100%' }}
        variant={'outlined'}
        elevation={0}
      >
        <DescriptionList
          termWidth={'200px'}
          data={data}
          disableGutters={true}
          stripEmpty={true}
        >
          <DescriptionItem label={'Campaign ID'} field={'campaign.id'} />
          <DescriptionItem
            field={'affiliate'}
            label={'Affiliate Name'}
            type={'link'}
            linkLabelField={'name'}
            onValueClick={handleOpenAffiliate}
          />
          <DescriptionItem label={'Affiliate ID'} field={'affiliate.id'} />
          <DescriptionItem label={'Publisher Name'} field={'publisher'} />
          <DescriptionItem label={'Real country'} field={'realCountry'} />
        </DescriptionList>
      </Paper>
    ),
  };
};
